<script lang="ts">
	import { onMount, type Snippet } from 'svelte';
	import LineSkeleton from './LineSkeleton.svelte';

	export type AsyncActionResult = Promise<{ keep_loading_state: boolean } | void>;

	let {
		additionalCondition = Promise.resolve(),
		additionalState = true,
		skeleton = lineSkeleton,
		children
	}: {
		additionalCondition?: Promise<unknown>;
		additionalState?: boolean;
		skeleton?: Snippet | undefined;
		children: Snippet;
	} = $props();

	onMount(async () => {
		await additionalCondition;
	});
</script>

{#snippet lineSkeleton()}
	<LineSkeleton />
{/snippet}

{#if !additionalState}
	{@render skeleton?.()}
{:else}
	{#await additionalCondition}
		{@render skeleton?.()}
	{:then}
		{@render children()}
	{/await}
{/if}
